export default __webpack_public_path__ + "assets/ico_booking_gold_locked-0ef98c05.svg";